/* Fortune Compare — pre-owned shelf only.
   Selection lives in sessionStorage (fw_compare) so it survives filters and
   pagination inside the shelf. Max three pieces. The sheet renders only from
   the data-* facts the toggles carry — no fetches, no invented values.

   Each column shows one photograph at a time inside a 3:4 frame, with the
   house square arrows beneath it to page through the sides of the piece
   (wrapping, never autoplaying), the description when the piece has one, and
   the fact ledger. On a phone the columns become a swipe rail, one piece
   82vw wide at a time, so "side by side" survives the narrow screen. */
(function () {
  'use strict';
  var KEY = 'fw_compare';
  var MAX = 3;
  /* THE FACT CONTRACT — same keys, labels and order as the toggle snippet,
     the PDP preset and the PDP template. Keys here are the data-fact-* names
     (underscore → hyphen). */
  var FACTS = [
    ['condition', 'Condition'],
    ['brand', 'Brand'],
    ['cap-construction', 'Cap construction'],
    ['hair-color', 'Colour & shade'],
    ['hair-length', 'Length'],
    ['cut-layers', 'Cut & layers'],
    ['style-done', 'Styling'],
    ['bangs', 'Bangs'],
    ['cap-size', 'Cap size'],
    ['hair-quality', 'Hair quality'],
    ['wear-assessment', 'Wear'],
    ['remaining-life', 'Estimated time left'],
    ['certified-cleaned', 'Cleaned & certified'],
    ['size', 'Size, as tagged'],
    ['estimated-age', 'Estimated age']
  ];
  var ARROW_PREV = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14.5 5.5 8 12l6.5 6.5"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9.5 5.5 16 12l-6.5 6.5"/></svg>';

  var root = document.querySelector('[data-fw-compare-root]');
  if (!root) return;
  var tray = root.querySelector('[data-fw-cmp-tray]');
  var thumbs = root.querySelector('[data-fw-cmp-thumbs]');
  var countEl = root.querySelector('[data-fw-cmp-count]');
  var goBtn = root.querySelector('[data-fw-cmp-go]');
  var clearBtn = root.querySelector('[data-fw-cmp-clear]');
  var sheet = root.querySelector('[data-fw-cmp-sheet]');
  var sheetBody = root.querySelector('[data-fw-cmp-sheet-body]');
  var posEl = root.querySelector('[data-fw-cmp-pos]');
  var live = root.querySelector('[data-fw-cmp-live]');
  var sheetItems = [];
  var railTick = 0;

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(items) {
    try { sessionStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX))); } catch (e) { /* private mode */ }
  }
  function say(msg) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); } }
  /* Everything that lands in innerHTML goes through here — text and URLs
     alike; escaping a Shopify CDN URL changes nothing it needs. */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imagesOf(i) {
    var list = Array.isArray(i.images) ? i.images.filter(Boolean) : [];
    if (!list.length && i.image) list = [i.image];
    return list;
  }

  function dataFromToggle(btn) {
    var images = (btn.dataset.images || '').split('|').filter(Boolean);
    var d = {
      handle: btn.dataset.handle,
      title: btn.dataset.title,
      url: btn.dataset.url,
      price: btn.dataset.price,
      was: btn.dataset.was || '',
      image: btn.dataset.image || '',
      images: images,
      description: btn.dataset.description || '',
      available: btn.dataset.available !== 'false',
      facts: {}
    };
    FACTS.forEach(function (f) {
      var v = btn.getAttribute('data-fact-' + f[0]);
      if (v) d.facts[f[0]] = v;
    });
    return d;
  }

  function refresh() {
    var items = read();
    // toggle states on visible cards
    document.querySelectorAll('[data-fw-cmp-toggle]').forEach(function (btn) {
      var on = items.some(function (i) { return i.handle === btn.dataset.handle; });
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var full = items.length >= MAX && !on;
      btn.classList.toggle('is-blocked', full);
      btn.setAttribute('aria-disabled', full ? 'true' : 'false');
    });
    // tray
    if (!tray) return;
    if (items.length === 0) {
      tray.hidden = true;
      document.body.classList.remove('fw-cmp-open-tray');
      return;
    }
    tray.hidden = false;
    document.body.classList.add('fw-cmp-open-tray');
    thumbs.innerHTML = '';
    items.forEach(function (i) {
      var cell = document.createElement('span');
      cell.className = 'fw-cmp-tray__thumb';
      cell.innerHTML = (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') +
        '<button type="button" class="fw-cmp-tray__remove" aria-label="Remove ' + esc(i.title) + ' from compare">&times;</button>';
      cell.querySelector('.fw-cmp-tray__remove').addEventListener('click', function () {
        write(read().filter(function (x) { return x.handle !== i.handle; }));
        say(i.title + ' removed.');
        refresh();
      });
      thumbs.appendChild(cell);
    });
    countEl.textContent = items.length + ' of ' + MAX + ' selected';
    goBtn.disabled = items.length < 2;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fw-cmp-toggle]');
    if (!btn) return;
    e.preventDefault();
    var items = read();
    var on = items.some(function (i) { return i.handle === btn.dataset.handle; });
    if (on) {
      write(items.filter(function (i) { return i.handle !== btn.dataset.handle; }));
      say(btn.dataset.title + ' removed from compare.');
    } else {
      if (items.length >= MAX) { say('Compare is full — remove a piece first.'); return; }
      items.push(dataFromToggle(btn));
      write(items);
      say(btn.dataset.title + ' added to compare.');
    }
    refresh();
  });

  if (clearBtn) clearBtn.addEventListener('click', function () { write([]); say('Compare cleared.'); refresh(); });

  /* ---------- the photograph, one side at a time ---------- */
  function photoAlt(i, idx, n) {
    return i.title + (n > 1 ? ', photo ' + (idx + 1) + ' of ' + n : '');
  }
  function figureHtml(i, col) {
    var imgs = imagesOf(i);
    var n = imgs.length;
    var frame = n
      ? '<img class="fw-cmp-col__photo" src="' + esc(imgs[0]) + '" alt="' + esc(photoAlt(i, 0, n)) + '" loading="lazy" decoding="async">'
      : '<span class="fw-cmp-col__photo fw-cmp-col__photo--empty" aria-hidden="true"></span>';
    var nav = n > 1
      ? '<div class="fw-cmp-col__nav">' +
          '<button type="button" class="fw-carousel-nav__btn fw-cmp-col__arrow" data-fw-cmp-prev aria-label="Previous photo">' + ARROW_PREV + '</button>' +
          '<span class="fw-cmp-col__count" data-fw-cmp-photo-count aria-hidden="true">1 / ' + n + '</span>' +
          '<button type="button" class="fw-carousel-nav__btn fw-cmp-col__arrow" data-fw-cmp-next aria-label="Next photo">' + ARROW_NEXT + '</button>' +
        '</div>'
      : '';
    return '<figure class="fw-cmp-col__figure" data-fw-cmp-figure data-col="' + col + '" data-index="0">' +
      '<div class="fw-cmp-col__frame">' + frame + '</div>' + nav + '</figure>';
  }
  function preload(url) { if (url) { var im = new Image(); im.src = url; } }
  function stepPhoto(figure, dir) {
    var i = sheetItems[Number(figure.dataset.col)];
    if (!i) return;
    var imgs = imagesOf(i);
    var n = imgs.length;
    if (n < 2) return;
    var idx = (Number(figure.dataset.index) + dir + n) % n;
    figure.dataset.index = String(idx);
    var img = figure.querySelector('.fw-cmp-col__photo');
    if (img) { img.src = imgs[idx]; img.alt = photoAlt(i, idx, n); }
    var c = figure.querySelector('[data-fw-cmp-photo-count]');
    if (c) c.textContent = (idx + 1) + ' / ' + n;
    preload(imgs[(idx + dir + n) % n]);
    say('Photo ' + (idx + 1) + ' of ' + n + '.');
  }

  /* ---------- mobile rail position ("1 of 3") ---------- */
  function railState() {
    var rail = sheetBody.querySelector('.fw-cmp-cols');
    if (!posEl || !rail) return;
    var cols = rail.querySelectorAll('.fw-cmp-col');
    var scrolls = cols.length > 1 && rail.scrollWidth > rail.clientWidth + 1;
    posEl.hidden = !scrolls;
    if (!scrolls) return;
    var mid = rail.scrollLeft + rail.clientWidth / 2;
    var best = 0, bestD = Infinity;
    cols.forEach(function (col, k) {
      var d = Math.abs(col.offsetLeft + col.offsetWidth / 2 - mid);
      if (d < bestD) { bestD = d; best = k; }
    });
    posEl.textContent = (best + 1) + ' of ' + cols.length;
  }
  function onRail() {
    if (railTick) return;
    railTick = requestAnimationFrame(function () { railTick = 0; railState(); });
  }

  function openSheet() {
    var items = read();
    if (items.length < 2) return;
    sheetItems = items;
    // union of populated fact rows; rows nobody has are dropped
    var rows = FACTS.filter(function (f) {
      return items.some(function (i) { return i.facts[f[0]]; });
    });
    var cols = items.map(function (i, col) {
      var factsHtml = rows.map(function (f) {
        var v = i.facts[f[0]];
        return '<div class="fw-cmp-col__row"><span class="fw-cmp-col__key">' + esc(f[1]) + '</span><span class="fw-cmp-col__val">' + (v ? esc(v) : '<span aria-label="Not recorded">&mdash;</span>') + '</span></div>';
      }).join('');
      var price = '<p class="fw-cmp-col__price">' + (i.was ? '<s>' + esc(i.was) + '</s> ' : '') + esc(i.price) + '</p>';
      var desc = i.description ? '<p class="fw-cmp-col__desc">' + esc(i.description) + '</p>' : '';
      var cta = i.available
        ? '<a class="fw-link fw-cmp-col__cta" href="' + esc(i.url) + '">See this piece</a>'
        : '<span class="fw-cmp-col__sold">Sold</span>';
      return '<article class="fw-cmp-col">' + figureHtml(i, col) +
        '<h3 class="fw-cmp-col__title">' + esc(i.title) + '</h3>' + price + desc +
        '<div class="fw-cmp-col__facts">' + factsHtml + '</div>' + cta + '</article>';
    }).join('');
    sheetBody.innerHTML = '<div class="fw-cmp-cols fw-cmp-cols--' + items.length + '" data-fw-cmp-rail>' + cols + '</div>';
    sheetBody.scrollTop = 0;
    var rail = sheetBody.querySelector('[data-fw-cmp-rail]');
    if (rail) { rail.scrollLeft = 0; rail.addEventListener('scroll', onRail, { passive: true }); }
    sheet.hidden = false;
    document.body.classList.add('fw-cmp-open-sheet');
    sheet.querySelector('[data-fw-cmp-close]').focus();
    document.addEventListener('keydown', escClose);
    window.addEventListener('resize', onRail);
    railState();
  }
  function closeSheet() {
    sheet.hidden = true;
    document.body.classList.remove('fw-cmp-open-sheet');
    document.removeEventListener('keydown', escClose);
    window.removeEventListener('resize', onRail);
    if (goBtn) goBtn.focus();
  }
  function escClose(e) { if (e.key === 'Escape') closeSheet(); }

  if (goBtn) goBtn.addEventListener('click', openSheet);
  if (sheet) {
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-fw-cmp-close]') || e.target === sheet) { closeSheet(); return; }
      var prev = e.target.closest('[data-fw-cmp-prev]');
      var next = e.target.closest('[data-fw-cmp-next]');
      if (!prev && !next) return;
      var figure = (prev || next).closest('[data-fw-cmp-figure]');
      if (figure) stepPhoto(figure, prev ? -1 : 1);
    });
    /* Left/Right while focus sits inside a column's figure (the arrows are
       real buttons, so Enter/Space already work) pages the photograph. */
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var figure = e.target.closest && e.target.closest('[data-fw-cmp-figure]');
      if (!figure) return;
      e.preventDefault();
      stepPhoto(figure, e.key === 'ArrowLeft' ? -1 : 1);
    });
  }

  refresh();
})();
